import { useCallback, useEffect, useState } from 'react'

import {
  getUnreadInboxNotifications,
  transformUnreadNotificationsResponse,
} from '@marketplace-web/inbox-notifications/inbox-notifications-data'

const useUnreadNotificationsCount = () => {
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState<number>(0)

  const fetchUnreadNotificationsCount = useCallback(async () => {
    await getUnreadInboxNotifications().then(
      (response: Awaited<ReturnType<typeof getUnreadInboxNotifications>>) => {
        if ('errors' in response) return
        setUnreadNotificationsCount(transformUnreadNotificationsResponse(response))
      },
    )
  }, [])

  useEffect(() => {
    fetchUnreadNotificationsCount()
  }, [fetchUnreadNotificationsCount])

  return {
    unreadNotificationsCount,
    fetchUnreadNotificationsCount,
  }
}

export default useUnreadNotificationsCount
